export enum Popups {
  WIN_POPUP = 'win-popup',
  WHATS_NEW = 'whats-new',
  NOTIFICATION_POPUP = 'push_notifications',
  FEEDBACK_POPUP = 'feedback',
  FACEBOOK_POPUP = 'facebook-banner',
  MAGIC_WAND_POPUP = 'magic-wand',
  OUT_MAGIC_WAND_POPUP = 'out-wand',
  OUT_MOVE_WAND_POPUP = 'out-move-wand',
  OUT_MOVE_ADS_POPUP = 'out-move-ads',
  OUT_UNDO_POPUP = 'out-undo',
  KING_POPUP = 'king-popup',
  STORIES_NO_TICKETS_POPUP = 'stories_no_tickets',
  NO_ADS_POPUP = 'no_ads',
  STORIES_CONGRATULATIONS_POPUP = 'stories_congratulations',
  STORIES_USE_TICKETS_POPUP = 'stories_use_tickets',
  ADBLOCKER_POPUP = 'adblocker',
  TUTORIAL_START = 'tutorial_start',
  TUTORIAL_COMPLETED = 'tutorial_completed',
  TUTORIAL_RESTART = 'tutorial_restart',
  TUTORIAL_SKIP = 'tutorial_skip',
  TUTORIAL_COMPLETED_SPIDER = 'tutorial_completed_spider',
  NO_HINTS_POPUP = 'no-hints',
}
export interface PopupState<TData = any> {
  isOpen: boolean;
  data?: TData;
}

export interface WinPopupData {
  timeFormatted?: string;
  moves?: number;
  recordPercent?: number;
  bestTimeFormatted?: string;
  bestMoves?: number;
  ticketsWon?: number;
  gameClass?: string; // e.g. win-popup-game-Klondike
  isBestTime?: boolean;
  isBestMoves?: boolean;
}

export type WhatsNewPopupData = {};

export interface KingPopupData {
  textKey: string;
  isNotification: boolean;
}

export interface StoriesNoTicketsPopupData {
  storyId: string;
  imageIndex: number;
}

export interface StoriesCongratulationsPopupData {
  storyId: string;
  imageSrc: string;
}

export type PopupStateData = WinPopupData | WhatsNewPopupData | KingPopupData | StoriesNoTicketsPopupData | StoriesCongratulationsPopupData;

export type PopupsState = Partial<Record<Popups, PopupState<PopupStateData>>>;

export enum PopupsActionTypes {
  OPEN_POPUP = 'OPEN_POPUP',
  CLOSE_POPUP = 'CLOSE_POPUP',
}

export interface OpenPopupAction<TData = any> {
  type: PopupsActionTypes.OPEN_POPUP;
  payload: { id: Popups; data?: TData };
}

export interface ClosePopupAction {
  type: PopupsActionTypes.CLOSE_POPUP;
  payload: { id: Popups };
}

export type PopupsAction = OpenPopupAction<any> | ClosePopupAction;


